var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered/Search/filter-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C9.44772 2 9 2.44772 9 3V4H2V6H9V7C9 7.55228 9.44772 8 10 8H11C11.5523 8 12 7.55228 12 7V6V4V3C12 2.44772 11.5523 2 11 2H10ZM14 4H22V6H14V4ZM15 9C14.4477 9 14 9.44772 14 10V11H2V13H14V14C14 14.5523 14.4477 15 15 15H16C16.5523 15 17 14.5523 17 14V13V11V10C17 9.44772 16.5523 9 16 9H15ZM19 11H22V13H19V11ZM4 17C4 16.4477 4.44772 16 5 16H6C6.55228 16 7 16.4477 7 17V18V20V21C7 21.5523 6.55228 22 6 22H5C4.44772 22 4 21.5523 4 21V20H2V18H4V17ZM22 18H9V20H22V18Z",
    fill: "#090B0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTune);
export default __webpack_public_path__ + "static/media/tune.b03ddb17dce4e9beaddb4560c5772812.svg";
export { ForwardRef as ReactComponent };